import React, { useEffect, useState } from "react";
import "antd/dist/antd";
import "../../Onboarding/Onboarding.scss";
import OnboardingTasks from "./OnboardingTasks";
import { Button, Card, Modal } from "antd";
import useOnboardingProcess from "Hooks/AdminHooks/useOnboardingProcess";

const HiringOnboarding = () => {
  const { formData, setFormData, handleSubmit, isSubmitted, handleNavigation } =
    useOnboardingProcess();
  const [isModalVisible, setIsModalVisible] = useState(false);

  useEffect(() => {
    if (isSubmitted) {
      setIsModalVisible(true);
    }
  }, [isSubmitted]);

  return (
    <>
      <Modal
        open={isModalVisible}
        closable={false}
        footer={null}
        centered
        styles={{
          body: {
            height: "80px",
            textAlign: "center",
          },
        }}
      >
        <p style={{ textAlign: "center", fontSize: "18px" }}>
          You have already onboarded this employee
        </p>
        {isSubmitted && (
          <Button className="btn-primary" onClick={handleNavigation}>
            Personal Info
          </Button>
        )}
      </Modal>
      {!isSubmitted && (
        <>
          <Card title="New Hiring Onboarding Checklists" className="card-professional">
            <OnboardingTasks formData={formData} setFormData={setFormData} />

            <div className="col-md-12">
              {!isSubmitted && (
                <Button className="btn-primary" style={{ float: "inline-end" }} onClick={handleSubmit}>
                  Submit
                </Button>
              )}
            </div>
          </Card>
        </>
      )}
    </>
  );
};

export default HiringOnboarding;
